import { ReactNode } from 'react';
import { POSITIVE_INFINITY, Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { ProductData } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { useProductTableColumns } from './columns';
import { CategoryActionButton } from './CategoryActionButton';

interface Props {
    amountOfRows: number;
    data: ProductData[];
    productCategoryId?: string | null;
    subtitle?: ReactNode;
    title: ReactNode;
    productCategoryName: string;
}

export const ProductTable = ({
    amountOfRows,
    data,
    productCategoryId,
    subtitle,
    title,
    productCategoryName,
}: Props) => {
    const [tableState, setTableState] = useTableState<ProductData>({
        pagination: {
            pageSize: POSITIVE_INFINITY,
        },
    });
    const columns = useProductTableColumns();
    return (
        <TableProvider onStateChange={setTableState} state={tableState} columns={columns} as="div">
            <TableHeader
                rightSide={productCategoryId ? <CategoryActionButton productCategoryId={productCategoryId} /> : null}
                subTitle={subtitle}
                title={title}
                data-test-product-table-header={`${productCategoryId || ''}_${productCategoryName}`}
            />
            <Table
                amountOfRows={amountOfRows}
                data={data}
                emptyState={{
                    primaryText: lt('ProductCategoryEmptyTableLabel'),
                }}
                fixedFirstColumn
                fixedLastColumn
                uniqueRowId="id"
                data-test-product-table={`${productCategoryId || ''}_${productCategoryName}`}
            />
        </TableProvider>
    );
};
